'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _templateObject = _taggedTemplateLiteral(['\n  0% {\n    background-position: 0% 50%;\n  }\n\n  50% {\n    background-position: 100% 51%;\n  }\n\n  100% {\n    background-position: 0% 50%;\n  }\n'], ['\n  0% {\n    background-position: 0% 50%;\n  }\n\n  50% {\n    background-position: 100% 51%;\n  }\n\n  100% {\n    background-position: 0% 50%;\n  }\n']);

var _styledComponents = require('styled-components');

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var GhostAnimation = (0, _styledComponents.keyframes)(_templateObject);

exports.default = GhostAnimation;


//////////////////
// WEBPACK FOOTER
// ./node_modules/base-components/build/elements/GhostIndicator/GhostAnimation.js
// module id = 1517
// module chunks = 2